import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { swalAlert, swalConfirm, swalErrorAlert } from '../../../utils/swal/swal'
import { useAdminStore } from '../../../store/userStore'
import { adminDeleteSchoolRecordReplyApi, adminGetSchoolRecordReplyApi, adminSaveSchoolRecordReplyApi, adminUpdateSchoolRecordReplyApi } from '../../../api/admin/schoolRecord'

const SchoolRecordReply = ({ schoolRecordId }) => {
    /* zustand */
    const { adminInfo } = useAdminStore(state => state)

    /* State */
    const [replyList, setReplyList] = useState([])

    /* UseForm */
    const { register, handleSubmit, setValue } = useForm({
        defaultValues: {
            reply: ''
        }
    })

    /* UseEffect */
    useEffect(() => {
        getReplyList(schoolRecordId)
    }, [schoolRecordId])

    /* Methods */
    // 댓글리스트 가져오기
    const getReplyList = async (schoolRecordId) => {
        if (!schoolRecordId) return

        try {
            const response = await adminGetSchoolRecordReplyApi(schoolRecordId)
            if (response.data?.code === 200) {
                const replyListData = response.data?.resData
                setReplyList(replyListData)
            }
            return

        } catch (error) {
            console.log(error);
            swalErrorAlert('댓글 조회 에러', '생활기록부 댓글을 조회하는 도중에 에러가 발생하였습니다.')
            return
        }
    }

    // 댓글 작성
    const onSubmit = async (data) => {
        if (!adminInfo?.user_id || !schoolRecordId) return

        if (!data?.reply || data.reply.trim() === '') {
            swalAlert('', '댓글을 입력해 주세요.', '', '확인')
            return
        }

        try {
            const requestData = {
                schoolRecordId,
                userId: adminInfo?.user_id,
                reply: data.reply
            }

            await adminSaveSchoolRecordReplyApi(requestData)
            swalAlert('저장 완료', '댓글을 저장하였습니다.', 'success', '확인', () => { window.location.reload(true); })

        } catch (error) {
            console.log(error);
            swalErrorAlert('댓글 저장 에러', '생활기록부 댓글을 저장하는 도중에 에러가 발생하였습니다.')
            return
        }
    }

    return (
        <div>
            <div>
                <ul className=''>
                    {replyList && replyList.map((item, index) => {
                        const isMine = adminInfo?.user_id === item.user_id

                        return (
                            <ReplyItem key={`reply-${item.id}`} item={item} isMine={isMine} />
                        )
                    })}

                    {replyList.length === 0 && <li>작성된 댓글이 없습니다.</li>}
                </ul>
            </div>
            <hr className='divider-row' />

            <form className='d-flex' onSubmit={handleSubmit(onSubmit)}>
                <textarea className='form-control' {...register('reply')} rows={4} placeholder='댓글을 입력해 주세요.' required />
                <button type='submit' className='btn btn-primary flex-shrink-0'>댓글 작성</button>
            </form>
        </div>
    )
}

const ReplyItem = ({ item, isMine }) => {
    const replyValue = item.reply

    /* UseState */
    const [reply, setReply] = useState(replyValue)
    const [updateToggle, setUpdateToggle] = useState(false) // 수정 state

    /* Methods */
    // 수정 - 상태변화
    const onClickOnToggle = () => {
        setUpdateToggle(true)
    }

    // 삭제 - delete api
    const onClickDelete = async (replyId) => {
        if (!replyId) return

        swalConfirm('댓글 삭제', '댓글을 삭제하시겠습니까?', 'question', '삭제', '취소',
            async () => {
                try {
                    await adminDeleteSchoolRecordReplyApi(replyId)
                    swalAlert('삭제 완료', '댓글을 삭제하였습니다.', 'success', '확인', () => { window.location.reload(true); })

                } catch (error) {
                    console.log(error);
                    swalErrorAlert('댓글 삭제 에러', '생활기록부 댓글을 삭제하는 도중에 에러가 발생하였습니다.')
                    return
                }
            },
            () => { return }
        )
    }

    // 저장 - update api
    const onClickSave = async (replyId, reply) => {
        if (!replyId) return
        if (reply.trim() === '') {
            swalAlert('', '댓글을 입력해 주세요.', '', '확인')
            return
        }

        try {
            // console.log("저장:" + replyId)
            // console.log(reply);
            const requestData = {
                replyId,
                reply
            }
            await adminUpdateSchoolRecordReplyApi(requestData)

            swalAlert('저장 완료', '댓글을 저장하였습니다.', 'success', '확인', () => { window.location.reload(true); })

        } catch (error) {
            console.log(error);
            swalErrorAlert('댓글 저장 에러', '생활기록부 댓글을 저장하는 도중에 에러가 발생하였습니다.')
            return
        }
    }

    // 취소 - 상태변화
    const onClickOffToggle = () => {
        setReply(replyValue)
        setUpdateToggle(false)
    }

    return (
        <li className='py-3'>
            {item.is_updated === 0 ?
                <div>
                    <b>{item.user_name}</b> <span style={{ fontSize: "14px", fontWeight: "300" }}>{item.created_at}</span>
                </div>
                :
                <div>
                    <b>{item.user_name}</b> <span style={{ fontSize: "14px", fontWeight: "300" }}>{item.created_at} (수정됨)</span>
                </div>
            }

            <div>
                <textarea className='form-control' disabled={!updateToggle} onChange={(e) => { setReply(e.target.value) }} value={reply} required />
            </div>

            {isMine && (
                updateToggle ?
                    <div className='text-end'>
                        <button type='button' className='btn btn-sm text-primary' onClick={() => onClickSave(item.id, reply)}>저장</button>
                        <button type='button' className='btn btn-sm' onClick={onClickOffToggle}>취소</button>
                    </div>
                    :
                    <div className='text-end'>
                        <button type='button' className='btn btn-sm text-primary' onClick={onClickOnToggle}>수정</button>
                        <button type='button' className='btn btn-sm text-danger' onClick={() => onClickDelete(item.id)}>삭제</button>
                    </div>
            )}
        </li>
    )
}

export default SchoolRecordReply